// Function loadNewsroomBlock loads the NewsroomBlock class by dynamically importing the js on demand if needed

export function loadNewsroomBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-newsroom-block-chunk" */ '../widgets/newsroomBlock').then(wg => {

		const { NewsroomBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="NewsroomBlock"]');

		if(!$wg) {
			// console.info('NewsroomBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="NewsroomBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new NewsroomBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new NewsroomBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the NewsroomBlock widget');

}
